module.exports = __webpack_public_path__ + "img/computerShadow.b337c8f6.png";